const LineOfBusinessToNameMapping = {
  MCAID: 'Medicaid',
  COM: 'Commercial',
  MA: 'Medicare',
};

export default LineOfBusinessToNameMapping;
